import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/layout/admin';
import * as Unicons from '@iconscout/react-unicons';
import Breadcrumbs from '../../components/elements/Breadcrumbs';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getExpectationFormDetail } from '../../services/expectationForm';
import { Card, Drawer, Flex, Popover, Text } from '@mantine/core';
import Button from '../../components/elements/Button';
import { FiChevronRight, FiDownload, FiEdit, FiEye } from 'react-icons/fi';
import DetailFormMethod from '../../components/fragments/DetailFormMethod';
import dayjs from 'dayjs';
import id from 'dayjs/locale/id';
import { dateFormat } from '../../utilities/dataFormat';
import { RaterGroups } from '../../types/rater';
import './styles.scss';
import { PDFDownloadLink } from '@react-pdf/renderer';
import DetailDocument from './DetailDocument';
import { useDisclosure } from '@mantine/hooks';
import { renderDate } from '../../utilities/renderDate';

const PrincipalExpectationFormDetailPage = (props) => {
  const params: any = useParams();
  const [dataRater, setDataRater] = useState<RaterGroups>(null);
  const [dataType, setDataType] = useState<string[]>([
    'Reliability',
    'Assurance',
    'Tangibles',
    'Empathy',
    'Responsiveness'
  ]);
  const [noteList, setNoteList] = useState(null);
  const [notesExpectation, setNotesExpectation] = useState(null);

  // Queries
  const fetchedExpectationForm = useQuery({
    queryKey: ['getExpectationFormDetail'],
    queryFn: () => getExpectationFormDetail(params?.id)
  });

  const [opened, { open, close }] = useDisclosure(false);
  const [insertID, setInsertID] = useState('');
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (
      fetchedExpectationForm?.data?.data?.data &&
      fetchedExpectationForm?.data?.data?.data.length > 0
    ) {
      if (
        fetchedExpectationForm?.data?.data?.data[index]?.listData &&
        fetchedExpectationForm?.data?.data?.data[index]?.listData.length > 0
      ) {
        const grouped = fetchedExpectationForm?.data?.data?.data[
          index
        ]?.listData.reduce((acc, item) => {
          const key = item.jenis;
          if (dataType.includes(key)) {
            acc[key].push(item);
          }
          return acc;
        }, Object.fromEntries(dataType.map((jenis) => [jenis, []])));

        setDataRater(grouped);

        const mapping = {
          Reliability: ['R1'],
          Assurance: ['A'],
          Tangibles: ['T'],
          Empathy: ['E'],
          Responsiveness: ['R2']
        };

        const results = dataType.reduce((acc, category) => {
          acc[category] = fetchedExpectationForm?.data?.data?.data[
            index
          ]?.notes.filter((item) => mapping[category].includes(item.jenis));
          return acc;
        }, {});

        setNoteList(results);
      }
    }
  }, [fetchedExpectationForm?.data?.data?.data, index]);

  return (
    <AdminLayout>
      <Breadcrumbs
        pageTitle="Expectation Form Detail"
        itemList={[
          {
            title: 'RATER',
            href: '#',
            icon: <Unicons.UilFileCopyAlt size={16} />
          },
          {
            title: 'Expectation Form',
            href: '/principal/principal-expectation-form'
          },
          {
            title: 'Expectation Form Detail',
            href: '#'
          }
        ]}
      />
      <Drawer
        opened={opened}
        onClose={close}
        title="Update Trail"
        position={'right'}
      >
        {fetchedExpectationForm?.data?.data?.data.map((item, index) => (
          <Card
            withBorder
            radius={'lg'}
            mt={index === 0 ? 0 : 10}
            style={{
              cursor: 'pointer',
              borderColor: insertID === item.updatedId ? 'purple' : '#E0E0E0',
              borderWidth: insertID === item.updatedId ? '2px' : '1px'
            }}
          >
            <Flex
              key={index}
              align="center"
              justify="space-between"
              className={`rater-form-detail__drawer-item ${
                index === 0 ? 'active' : ''
              }`}
              onClick={() => {
                setIndex(index);
                setInsertID(item.updatedId);
                close();
              }}
            >
              <div>
                <Text>{item.userIn}</Text>
                <Text
                  style={{
                    color: '#9E9E9E',
                    fontSize: '12px'
                  }}
                >
                  {renderDate(item.dateIn, 'datetime')}
                </Text>
                <Text
                  style={{
                    color: '#9E9E9E',
                    fontSize: '12px'
                  }}
                >
                  Click to see the detail
                </Text>
              </div>
              <div>
                <FiChevronRight />
              </div>
            </Flex>
          </Card>
        ))}
      </Drawer>
      <Flex direction={{ base: 'column', sm: 'row' }} mb={16} gap={16}>
        <Flex
          direction={{ base: 'column', sm: 'row' }}
          flex={1}
          gap={16}
          align="flex-start"
        >
          <Flex direction="column">
            <p className="expectation-form-detail__title m-0">Submitted Date</p>
            <h5 className="expectation-form-detail__description m-0">
              {fetchedExpectationForm?.data?.data?.data[index]?.dateIn
                ? dayjs(fetchedExpectationForm?.data?.data?.data[index]?.dateIn)
                    .locale(id)
                    .format(dateFormat('datetime'))
                : '-'}
            </h5>
          </Flex>
          <Flex direction="column">
            <p className="expectation-form-detail__title m-0">Submitted By</p>
            <h5 className="expectation-form-detail__description m-0">
              {fetchedExpectationForm?.data?.data?.data[index]?.userIn || '-'}
            </h5>
          </Flex>
          <Flex direction="column">
            <p className="expectation-form-detail__title m-0">
              Grand Total Score
            </p>
            <h5 className="expectation-form-detail__description m-0">
              {fetchedExpectationForm?.data?.data?.data[
                index
              ]?.rataexpectation.toFixed(2) || '-'}
            </h5>
          </Flex>
        </Flex>
        <Flex direction={{ base: 'column', sm: 'row' }}>
          {/* <div>
            <Button
              className="button__download"
              leftSection={<FiDownload size={24} />}
            >
              <PDFDownloadLink
                document={
                  <DetailDocument
                    dataRater={dataRater}
                    dataType={dataType}
                    dateIn={
                      fetchedExpectationForm?.data?.data?.data[index]?.dateIn
                    }
                    rataexpectation={
                      fetchedExpectationForm?.data?.data?.data[index]
                        ?.rataexpectation
                    }
                    userIn={
                      fetchedExpectationForm?.data?.data?.data[index]?.userIn
                    }
                  />
                }
                fileName={`Expectation-Form_Submitted-Date_${
                  fetchedExpectationForm?.data?.data?.data[index]?.dateIn
                    ? dayjs(
                        fetchedExpectationForm?.data?.data?.data[index]?.dateIn
                      )
                        .locale(id)
                        .format(dateFormat('datetime'))
                    : ''
                }_Submitted-By_${
                  fetchedExpectationForm?.data?.data?.data[index]?.userIn || ''
                }_Downloaded-At_${dayjs()
                  .locale(id)
                  .format('DD-MM-YYYY HH:mm:ss')}.pdf`}
              >
                {({ blob, url, loading, error }) =>
                  loading ? 'Loading document...' : 'Download'
                }
              </PDFDownloadLink>
            </Button>
          </div>
          <div
            style={{
              marginLeft: '10px'
            }}
          >
            <Button
              leftSection={<FiEdit size={24} />}
              variant={'outline'}
              onClick={() => {
                props.history.push(
                  `/management/expectation-form/detail/edit/${params.id}/${fetchedExpectationForm?.data?.data?.data[0]?.binusianID}`
                );
              }}
            ></Button>
          </div> */}
          {fetchedExpectationForm?.data?.data?.data.length > 1 && (
            <div
              style={{
                marginLeft: '10px'
              }}
            >
              <Button
                leftSection={<FiEye size={24} />}
                variant={'outline'}
                onClick={open}
              ></Button>
            </div>
          )}
        </Flex>
      </Flex>
      <Flex justify={'center'} mb={16}>
        <h3 className="expectation-form-detail__title-expectation m-0">
          EXPECTATION QUESTIONS USING <strong> R.A.T.E.R </strong> METHOD
        </h3>
      </Flex>
      <Flex gap={16} direction="column">
        {dataRater &&
          dataType.map((item, index) => {
            return (
              <DetailFormMethod
                title={item}
                notes={noteList && noteList[item]}
                notesExpectation={notesExpectation && notesExpectation[item]}
                data={dataRater[item]}
                key={index}
                type="expectation"
              />
            );
          })}
      </Flex>
      <Flex
        gap={4}
        align="center"
        justify="flex-start"
        p={16}
        mt={16}
        className="wrapper-grand-total"
      >
        <Popover width={200} position="bottom" withArrow shadow="md">
          <Popover.Target>
            <div className="summary-table-method__button_information">
              <Unicons.UilInfoCircle size={20} />
            </div>
          </Popover.Target>
          <Popover.Dropdown>
            <Text size="xs" fw={700}>
              Grand Total
            </Text>
            <Text size="xs">
              Is the result of the total rating score divided by 5 aspects
            </Text>
          </Popover.Dropdown>
        </Popover>

        <Text size="md" fw={700}>
          Grand Total :{' '}
          {fetchedExpectationForm?.data?.data?.data[
            index
          ]?.rataexpectation.toFixed(2)}
        </Text>
      </Flex>
    </AdminLayout>
  );
};

export default PrincipalExpectationFormDetailPage;
